module.exports = __webpack_public_path__ + "static/media/12.171fa539.JPG";